"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_redux_firebase_1 = require("react-redux-firebase");
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var CloseButton_1 = __importDefault(require("components/Buttons/CloseButton"));
var calculateKeyInsights_1 = require("utils/calculateKeyInsights");
var KeyInsightsItem_1 = __importDefault(require("./KeyInsightsItem"));
var PREFIX = 'KeyInsightsForm';
var classes = {
    wrapperTop: "".concat(PREFIX, "-wrapperTop"),
};
var Root = (0, styles_1.styled)('div')(function () {
    var _a;
    return (_a = {},
        _a["&.".concat(classes.wrapperTop)] = {
            width: 'calc(100% - 28px)',
            marginLeft: 8,
            marginTop: 32,
            marginBottom: 32,
        },
        _a);
});
var KeyInsightsForm = function (_a) {
    var _b;
    var serviceStatWithService = _a.serviceStatWithService, recommendations = _a.recommendations, closeForm = _a.closeForm;
    var firebaseInstance = (0, react_redux_firebase_1.useFirebase)();
    var keyInsights = react_1.default.useMemo(function () { return (0, calculateKeyInsights_1.getKeyInsightsDataFromReviews)(serviceStatWithService, recommendations); }, [serviceStatWithService, recommendations]);
    var _c = __read((0, react_1.useState)(serviceStatWithService.keyInsights || []), 2), chosenInsights = _c[0], setChoseInsights = _c[1];
    var submit = function () {
        firebaseInstance.firestore().collection('service_stats')
            .doc(serviceStatWithService.id)
            .update({ keyInsights: chosenInsights })
            .then(closeForm);
    };
    return ((0, jsx_runtime_1.jsxs)(Root, __assign({ className: (0, clsx_1.default)('roundBorders p-7', classes.wrapperTop) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "fs-md lh-3 color-primary" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "mr-7" }, { children: "Key Insights | Select 1-4 items" })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: submit }, { children: "Save" })), (0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: function () { return setChoseInsights([]); } }, { children: "Clear" })), !!((_b = serviceStatWithService.keyInsights) === null || _b === void 0 ? void 0 : _b.length)
                        && ((0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPrim, __assign({ onClick: function () { return serviceStatWithService.keyInsights && setChoseInsights(serviceStatWithService.keyInsights); } }, { children: "Reset" }))), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { closeAction: closeForm })] })), (0, jsx_runtime_1.jsx)("div", { children: keyInsights === null || keyInsights === void 0 ? void 0 : keyInsights.map(function (keyInsightData) {
                    var templateName = keyInsightData.templateName;
                    var index = chosenInsights.indexOf(templateName);
                    var order = index < 0 ? null : index + 1;
                    return ((0, jsx_runtime_1.jsx)(KeyInsightsItem_1.default, { onClick: function () { return setChoseInsights(order
                            ? chosenInsights.filter(function (chosenTemplName) { return chosenTemplName !== templateName; })
                            : __spreadArray(__spreadArray([], __read(chosenInsights), false), [templateName], false)); }, order: order || 0, data: keyInsightData, serviceName: serviceStatWithService.service.name }, templateName));
                }) })] })));
};
exports.default = KeyInsightsForm;
